// The account type a visitor picked on www before signing up
// (app.brxs.ca/login?mode=register&type=builder). Kept for this tab only so it
// survives the Google redirect. Onboarding highlights it; the visitor still confirms.
export const DEV_SIGNUP_TYPES = ['builder', 'reit_leasing', 'investor', 'commercial', 'property_manager'];
export const SIGNUP_TYPES = ['solo', 'team', 'brokerage', ...DEV_SIGNUP_TYPES];
const KEY = 'bricks-signup-type';
const ALIASES = {
  developer: 'builder', reit: 'reit_leasing', reits: 'reit_leasing', leasing: 'reit_leasing',
  individual: 'solo', agent: 'solo', agents: 'solo', teams: 'team', brokerages: 'brokerage',
  investors: 'investor', cre: 'commercial', landlord: 'property_manager', landlords: 'property_manager',
  pm: 'property_manager', 'property-manager': 'property_manager', 'property-managers': 'property_manager',
};

export function normalizeSignupType(raw) {
  const v = String(raw || '').trim().toLowerCase();
  const t = ALIASES[v] || v;
  return SIGNUP_TYPES.includes(t) ? t : null;
}

export function saveSignupIntent(search, store = globalThis.sessionStorage) {
  const t = normalizeSignupType(new URLSearchParams(search || '').get('type'));
  if (!t || !store) return null;
  try { store.setItem(KEY, t); } catch {}
  return t;
}

export function readSignupIntent(store = globalThis.sessionStorage) {
  try { return normalizeSignupType(store && store.getItem(KEY)); } catch { return null; }
}

export function clearSignupIntent(store = globalThis.sessionStorage) {
  try { store && store.removeItem(KEY); } catch {}
}

export const isDevSignupType = (t) => DEV_SIGNUP_TYPES.includes(t);

// One calm line under "Create your account." for the type the visitor picked on www.
// Sentence case, no product sub-brands. `slide` puts the matching login photo first.
const REGISTER_COPY = {
  solo: { line: 'Listing media, bookings and your deals in one place.', slide: 0 },
  team: { line: "Your team's listings, media and deals, in one place.", slide: 0 },
  brokerage: { line: 'Every agent, deal and listing in your office, in one place.', slide: 0 },
  builder: { line: 'Site progress you can see, from first dig to handover.', slide: 2 },
  reit_leasing: { line: 'Every property in your portfolio, photographed on a schedule.', slide: 1 },
  investor: { line: 'Acquisition captures and portfolio checks, deal by deal.', slide: 1 },
  commercial: { line: 'Leasing media and aerials for commercial space.', slide: 3 },
  property_manager: { line: 'Unit photos, condition reports and turnovers, by property.', slide: 1 },
};
const REGISTER_DEFAULT = { line: 'Media and the tools to run real estate, for every kind of property.', slide: 0 };

export function registerCopy(type) {
  return REGISTER_COPY[normalizeSignupType(type)] || REGISTER_DEFAULT;
}
